import { db } from "../utils/firestore";
import multiFirebaseService from "./MultiFirebase.service";
import { handleFirestoreError } from "../utils/firestoreIndexHandler";
import {
  // doc,
  // getDoc,
  collection,
  // addDoc,
  getDocs,
  // updateDoc,
  // deleteDoc,
  query,
  orderBy,
  where,
  startAfter,
  endBefore,
  limit,
  limitToLast,
  // setDoc,
  getCountFromServer,
  Timestamp,
} from "firebase/firestore";
import { generateTrigam } from "../utils/trigamUtils";
import { normalizarTermoBusca } from "../utils/searchableName";
// import { CommentsDisabled } from "@mui/icons-material";
// import { hasAllArrayElements } from "../utils/arrayUtils";
import { keepOrderIfNotDuplicated } from "../utils/conditionsUtils";
// import { Timestamp } from "firebase/firestore";
import GenericService from "./Generic.service";
import performanceMonitor from "../utils/performance-monitor";
import AuthenticatedApiService from "./AuthenticatedApiService";

//const dbCollection = db.collectionName("/contasgroups");

// ⚡ Cache de contagem (reduz custo do Firestore)
// getCountFromServer é cobrado como leitura(s). Buscas idênticas repetidas
// (re-render, digitação com mesmo filtro, navegação de páginas) reutilizam
// a contagem por um curto período em vez de recontar toda vez.
const COUNT_CACHE_TTL_MS = 30 * 1000; // 30 segundos
const _countCache = new Map(); // key -> { expiresAt, value }

class GenericVinculadoService {
  
  /**
   * Converte strings de data ISO de volta para objetos Timestamp do Firestore
   * Esta função é necessária porque a API retorna Date objects como strings ISO,
   * mas o cliente espera objetos Timestamp para compatibilidade
   */
  convertDateStringsToTimestamp = (obj) => {
    if (obj === null || obj === undefined) {
      return obj;
    }
    
    // Se for uma string que parece uma data ISO
    if (typeof obj === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(obj)) {
      try {
        const date = new Date(obj);
        return Timestamp.fromDate(date);
      } catch (error) {
        console.warn('Erro ao converter string para Timestamp:', obj, error);
        return obj;
      }
    }
    
    // Se for um array
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertDateStringsToTimestamp(item));
    }
    
    // Se for um objeto
    if (typeof obj === 'object' && obj.constructor === Object) {
      const converted = {};
      for (const [key, value] of Object.entries(obj)) {
        converted[key] = this.convertDateStringsToTimestamp(value);
      }
      return converted;
    }
    
    return obj;
  };

  //Implementado para evitar quebra dos servicos
  updateActiveState = async (collectionName, id, newStateValue, userId, userName) => {
    return await GenericService.updateActiveState(collectionName, id, newStateValue, userId, userName);
  };

  updateFederativeActiveState = async (collectionName, id, newStateValue, userId, userName) => {
    return await GenericService.updateFederativeActiveState(collectionName, id, newStateValue, userId, userName);
  };

  getAll = async (collectionName, orderby, ascDesc, showAllVersions, vinculo_idEntidade, vinculoTarget) => {
    const conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    conditions.push(orderBy(orderby, ascDesc));
    // if (pageSize !== null) conditions.push(limit(pageSize));
    // if (firstVisible !== null) conditions.push(endBefore(firstVisible));
    try {
      let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      return querySnapshot.docs;
    } catch (error) {
      await handleFirestoreError(error);
    }
  };

  getCollectionSize = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    operation,
    show_1_Active_2_Inactive_3_Both,
    associacaoIdTarget,
    associacaoTarget,
    showBloqueados
  ) => {

    // console.log("getCollectionSize(",
    // "collectionName:", collectionName,
    // "queryTarget:", queryTarget,
    // "queryText:", queryText,
    // "firstVisible:", firstVisible,
    // "lastVisible:", lastVisible,
    // "pageSize:", pageSize,
    // "orderby:", orderby,
    // "ascDesc:", ascDesc,
    // "showAllVersions:", showAllVersions,
    // "vinculo_idEntidade:", vinculo_idEntidade,
    // "vinculoTarget:", vinculoTarget,
    // "operation:", operation,
    // "show_1_Active_2_Inactive_3_Both:", show_1_Active_2_Inactive_3_Both,
    // "associacaoIdTarget:", associacaoIdTarget,
    // "associacaoTarget:", associacaoTarget,
    // "showBloqueados:", showBloqueados,
    // ")");

    if (lastVisible === undefined) lastVisible = null;
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    // //console.log("getCollectionSize => show_1_Active_2_Inactive_3_Both: ", show_1_Active_2_Inactive_3_Both);
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    if (operation !== undefined && typeof queryTarget === "string" && (typeof queryText === "object" || typeof queryText === "string"))
      conditions.push(where(queryTarget, operation, queryText));
    else conditions = [...conditions, ...this.getConditionsFromQueryFilter(queryTarget, queryText, collectionName)];

    if (associacaoIdTarget) {
      conditions.push(where("dadosFiliacao.vinculadoAEntidadeID", "==", associacaoIdTarget));
    }
    else if (associacaoTarget) {
      conditions.push(where("dadosFiliacao.vinculadoAEntidade", "==", associacaoTarget));
    }

    // conditions = [...conditions, ...this.getConditionsFromQueryFilter(queryTarget, queryText)];
    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions) conditions.push(where("metadados.successorId", "==", ""));
    if (show_1_Active_2_Inactive_3_Both !== 3) conditions.push(where("metadados.active", "==", show_1_Active_2_Inactive_3_Both === 1));
    if (showBloqueados) conditions.push(where("metadados.cancelado", "==", true));
    // if (pageSize !== null) conditions.push(limit(pageSize));
    // if (queryTarget !== orderby && queryText !== "") conditions.push(orderBy(queryTarget, ascDesc));
    // if (orderby !== "") conditions.push(orderBy(orderby, ascDesc));
    // if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    // if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    // let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    // return querySnapshot.docs.length;
    // console.log("getCollectionSize => conditions: ", conditions);

    // ⚡ Verificar cache (chave independe de paginação: firstVisible/lastVisible/pageSize)
    const _cacheKey = JSON.stringify([
      collectionName, queryTarget, queryText, orderby, ascDesc, showAllVersions,
      vinculo_idEntidade, vinculoTarget, operation, show_1_Active_2_Inactive_3_Both,
      associacaoIdTarget, associacaoTarget, showBloqueados,
    ]);
    const _cached = _countCache.get(_cacheKey);
    if (_cached && _cached.expiresAt > Date.now()) {
      return _cached.value;
    }

    const q = query(collection(db, collectionName), ...conditions);
    const snapshot = await getCountFromServer(q);
    // //console.log("count: ", snapshot.data().count);
    const _count = snapshot.data().count;
    _countCache.set(_cacheKey, { expiresAt: Date.now() + COUNT_CACHE_TTL_MS, value: _count });
    return _count;
  };

  getCollectionSizeByComplexFilter = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    operation
  ) => {

    //   return await this.getCollectionSearchByPrefix(
    //     collectionName,
    //     queryTarget,
    //     queryText,
    //     null,
    //     null,
    //     null,
    //     orderby,
    //     ascDesc,
    //     showAllVersions,
    //     vinculo_idEntidade,
    //     vinculoTarget,
    //     operation
    // )[1];

    if (lastVisible === undefined) lastVisible = null;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }

    if (queryText !== "") {
      if (queryText.searchInfo !== undefined) {
        if (queryText.searchInfo !== "") {
          if (queryText.searchInfo.indexOf("trigam") > -1) {
            conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText.searchInfo)]));
          } else {
            conditions.push(where(queryTarget, ">=", queryText.searchInfo));
            conditions.push(where(queryTarget, "<=", queryText.searchInfo + "\uf8ff"));
          }
        }
      }
      let queryTextArray = Object.entries(queryText);
      queryTextArray.forEach((item) => {
        if (item[0] !== "searchInfo")
          if (!["", "Todos", "Todas", "Selecione"].includes(item[1])) conditions.push(where(item[0], "==", item[1]));
      });
    }

    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    let snapshot = await getCountFromServer(query(collection(db, collectionName), ...conditions));
    return snapshot.data().count;
  };

  getCollectionSizeBySpecialConditions = async (
    collectionName,
    searchConditions,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    operation
  ) => {

    if (lastVisible === undefined) lastVisible = null;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    // //console.log("getCollectionSizeByComplexFilter => conditions: ", conditions);

    searchConditions.forEach((searchConditionItem) => {
      conditions.push(where(searchConditionItem.field, searchConditionItem.operator, searchConditionItem.value));
    });
    // //console.log("getCollectionSizeByComplexFilter => conditions: ", conditions);

    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));

    // console.log("getCollectionSizeByComplexFilter => collectionName:", collectionName, "conditions: ", conditions);
    const q = query(collection(db, collectionName), ...conditions);
    const snapshot = await getCountFromServer(q);
    // //console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getFilteredCollection = async (
    collectionName,
    filterTarget,
    operation,
    filterValue,
    firstVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    show_1_Active_2_Inactive_3_Both
  ) => {
    // //console.log(
    //   "getFilteredCollection(collectionName:",
    //   collectionName,
    //   "filterTarget:",
    //   filterTarget,
    //   "operation:",
    //   operation,
    //   "filterValue:",
    //   filterValue,
    //   "firstVisible:",
    //   firstVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "showAllVersions:",
    //   showAllVersions,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   "show_1_Active_2_Inactive_3_Both:",
    //   show_1_Active_2_Inactive_3_Both,
    //   ")"
    // );
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    // //console.log();
    // //console.log("conditions=", conditions);
    // //console.log("filterTarget=", filterTarget);
    // //console.log("filterValue=", filterValue);
    // //console.log("typeof filterTarget=", typeof filterTarget);
    // //console.log("typeof filterValue=", typeof filterValue);

    if (
      typeof filterTarget === "string" &&
      (typeof filterValue === "object" || typeof filterValue === "string" || typeof filterValue === "number")
    )
      conditions.push(where(filterTarget, operation, filterValue));
    else conditions = [...conditions, ...this.getConditionsFromQueryFilter(filterTarget, filterValue, collectionName)];
    // if (filterValue && filterValue !== "") conditions.push(where(filterTarget, operation, filterValue));

    // //console.log("getFilteredCollection => conditions=", conditions);

    if (!showAllVersions) conditions.push(where("metadados.successorId", "==", ""));
    if (show_1_Active_2_Inactive_3_Both === 1) conditions.push(where("metadados.active", "==", true));
    else if (show_1_Active_2_Inactive_3_Both === 2) conditions.push(where("metadados.active", "==", false));
    // //console.log("getFilteredCollection => conditions=", conditions);

    if (pageSize !== null) conditions.push(limit(pageSize));
    // if (orderby !== null && orderby !== "") conditions.push(orderBy(orderby, ascDesc));
    if (orderby !== null) {
      if (orderby !== "") {
        if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
        else conditions.push(orderBy(orderby, ascDesc));
      } else conditions.push(orderBy(orderby, ascDesc));
    }
    // if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));

    if (firstVisible !== null && firstVisible !== "") conditions.push(startAfter(firstVisible));
    // if (lastVisible !== null && lastVisible !== "") conditions.push(endBefore(lastVisible));


    conditions = keepOrderIfNotDuplicated(conditions);

    // if (collectionName === "agendamentos") {
    //   console.clear();
    //   // //console.log("typeof filterValue = ", typeof filterValue);
    //   // //console.log(
    //     "getFilteredCollection(collectionName:",
    //     collectionName,
    //     "filterTarget:",
    //     filterTarget,
    //     "operation:",
    //     operation,
    //     "filterValue:",
    //     filterValue,
    //     "firstVisible:",
    //     firstVisible,
    //     "pageSize:",
    //     pageSize,
    //     "orderby:",
    //     orderby,
    //     "ascDesc:",
    //     ascDesc,
    //     "showAllVersions:",
    //     showAllVersions,
    //     "vinculo_idEntidade:",
    //     vinculo_idEntidade,
    //     "vinculoTarget:",
    //     vinculoTarget,
    //     ")"
    //   );
    // //console.log("getFilteredCollection(", collectionName, ") => conditions=", conditions);
    // }
    try {
      let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      // //console.log("getFilteredCollection(", collectionName, ") with conditions=", conditions, " => querySnapshot.docs=", querySnapshot.docs);
      let collectionSize = await this.getCollectionSize(
        collectionName,
        filterTarget,
        filterValue,
        firstVisible,
        null,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget,
        operation,
        show_1_Active_2_Inactive_3_Both
      );
      // //console.log("getFilteredCollection(", collectionName, ") => collectionSize=", collectionSize);
      // //console.log("getFilteredCollection =>", querySnapshot.docs, "size:", collectionSize);
      return [querySnapshot.docs, collectionSize];
    } catch (error) {
      await handleFirestoreError(error);
    }
  };

  getCollectionSearchByPrefix = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    show_1_Active_2_Inactive_3_Both,
    associacaoIdTarget,
    associacaoTarget,
    showBloqueados,
    extraConditions,
  ) => {
    // console.log(
    //   "getCollectionSearchByPrefix(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "showAllVersions:",
    //   showAllVersions,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   "show_1_Active_2_Inactive_3_Both:",
    //   show_1_Active_2_Inactive_3_Both,
    //   "associacaoIdTarget:",
    //   associacaoIdTarget,
    //   "associacaoTarget:",
    //   associacaoTarget,
    //   "showBloqueados:",
    //   showBloqueados,
    //   "extraConditions:",
    //   extraConditions,
    //   ")"
    // );
    if (lastVisible === undefined) lastVisible = null;
    // //console.log("getCollectionSearchByPrefix() => show_1_Active_2_Inactive_3_Both=", show_1_Active_2_Inactive_3_Both);
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    conditions = [...conditions, ...this.getConditionsFromQueryFilter(queryTarget, queryText, collectionName)];
    if (associacaoIdTarget) {
      conditions.push(where("dadosFiliacao.vinculadoAEntidadeID", "==", associacaoIdTarget));
    }
    else if (associacaoTarget) {
      conditions.push(where("dadosFiliacao.vinculadoAEntidade", "==", associacaoTarget));
    }
    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions && !showBloqueados) conditions.push(where("metadados.successorId", "==", ""));
    // //console.log("getCollectionSearchByPrefix() => show_1_Active_2_Inactive_3_Both=", show_1_Active_2_Inactive_3_Both);
    if (show_1_Active_2_Inactive_3_Both === 1) {
      conditions.push(where("metadados.active", "==", true));
    } else if (show_1_Active_2_Inactive_3_Both === 2) {
      conditions.push(where("metadados.active", "==", false));
    } else if (show_1_Active_2_Inactive_3_Both === 3) {
    }
    // console.log("getCollectionSearchByPrefix() => showBloqueados=", showBloqueados);
    if (showBloqueados) conditions.push(where("metadados.cancelado", "==", true));
    // if (extraConditions !== null) conditions.push(extraConditions);
    // console.log("getCollectionSearchByPrefix() => extraConditions=", extraConditions);
    if (extraConditions !== undefined && extraConditions !== null) conditions = [...conditions, ...extraConditions];
    // if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    if (queryTarget !== orderby && queryText !== "") {
      conditions.push(orderBy(queryTarget, ascDesc));
    }
    conditions = keepOrderIfNotDuplicated(conditions);
    if (orderby !== "") {
      if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
      else conditions.push(orderBy(orderby, ascDesc));
    } else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);
    if (firstVisible !== null && firstVisible !== "") conditions.push(startAfter(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(endBefore(lastVisible));
    
    try {
      let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      let collectionSize = await this.getCollectionSize(
        collectionName,
        queryTarget,
        queryText,
        firstVisible,
        lastVisible,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget,
        undefined,
        show_1_Active_2_Inactive_3_Both,
        associacaoIdTarget,
        associacaoTarget,
        showBloqueados
      );
      //console.log("getCollectionSearchByPrefix() => collectionSize=", collectionSize);
      return [querySnapshot.docs, collectionSize];
    } catch (error) {
      await handleFirestoreError(error);
    }
  };

  getCollectionSearchByPrefixWithComplexFilter = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget
  ) => {
    //console.log(
    //   "getCollectionSearchByPrefixWithComplexFilter(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   ")"
    // );
    if (lastVisible === undefined) lastVisible = null;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }

    if (queryText !== "") {
      if (queryText.searchInfo !== undefined) {
        if (queryText.searchInfo !== "") {
          if (queryText.searchInfo.indexOf("trigam") > -1) {
            conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText.searchInfo)]));
          } else {
            conditions.push(where(queryTarget, ">=", queryText.searchInfo));
            conditions.push(where(queryTarget, "<=", queryText.searchInfo + "\uf8ff"));
          }
        }
      }
      let queryTextArray = Object.entries(queryText);
      queryTextArray.forEach((item) => {
        if (item[0] !== "searchInfo")
          if (!["", "Todos", "Todas", "Selecione"].includes(item[1])) conditions.push(where(item[0], "==", item[1]));
      });
    }

    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    // //console.log("getCollectionSearchByPrefixWithComplexFilter() => queryTarget=", queryTarget, "queryText=", queryText);
    if (queryTarget !== orderby && queryText !== "") conditions.push(orderBy(queryTarget, ascDesc));
    // //console.log("getCollectionSearchByPrefixWithComplexFilter() => orderby=", orderby);
    if (orderby !== "") {
      if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
      else conditions.push(orderBy(orderby, ascDesc));
    } else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);
    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    //console.log("getCollectionSearchByPrefixWithComplexFilter() => conditions=", conditions);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    // //console.log("getCollectionSearchByPrefixWithComplexFilter() => querySnapshot=", querySnapshot);
    let collectionSize = await this.getCollectionSizeByComplexFilter(
      collectionName,
      queryTarget,
      queryText,
      firstVisible,
      lastVisible,
      pageSize,
      orderby,
      ascDesc,
      showAllVersions,
      vinculo_idEntidade,
      vinculoTarget
    );
    // //console.log("getCollectionSearchByPrefix() => collectionSize=", collectionSize);
    return [querySnapshot.docs, collectionSize];
  };

  getCollectionSearchByPrefixWithComplexFilter_version2 = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget
  ) => {
    // console.log(
    //   "getCollectionSearchByPrefixWithComplexFilter_version2(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   ")"
    // );
    if (lastVisible === undefined) lastVisible = null;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }

    // if (queryText !== "") {
    //   if (queryText.searchInfo !== "") {
    //     if (queryText.searchInfo.indexOf("trigam") > -1) {
    //       conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText.searchInfo)]));
    //     } else {
    //       conditions.push(where(queryTarget, ">=", queryText.searchInfo));
    //       conditions.push(where(queryTarget, "<=", queryText.searchInfo + "\uf8ff"));
    //     }
    //   }
    //   let queryTextArray = Object.entries(queryText);
    //   queryTextArray.forEach((item) => {
    //     if (item[0] !== "searchInfo")
    //       if (!["", "Todos", "Todas", "Selecione"].includes(item[1])) conditions.push(where(item[0], "==", item[1]));
    //   });
    // }

    conditions = [...conditions, ...this.getConditionsFromQueryFilter_version2(queryTarget, queryText)];
    //console.log("getCollectionSearchByPrefixWithComplexFilter_version2() => conditions=", conditions);
    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    // //console.log("getCollectionSearchByPrefixWithComplexFilter() => queryTarget=", queryTarget, "queryText=", queryText);
    if (queryTarget !== orderby && queryText !== "") conditions.push(orderBy(queryTarget, ascDesc));
    // //console.log("getCollectionSearchByPrefixWithComplexFilter() => orderby=", orderby);
    if (orderby !== "") {
      if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
      else conditions.push(orderBy(orderby, ascDesc));
    } else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);
    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    //console.log("getCollectionSearchByPrefixWithComplexFilter() => conditions=", conditions);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    // //console.log("getCollectionSearchByPrefixWithComplexFilter() => querySnapshot=", querySnapshot);
    let collectionSize = await this.getCollectionSizeByComplexFilter(
      collectionName,
      queryTarget,
      queryText,
      firstVisible,
      lastVisible,
      pageSize,
      orderby,
      ascDesc,
      showAllVersions,
      vinculo_idEntidade,
      vinculoTarget
    );
    // //console.log("getCollectionSearchByPrefix() => collectionSize=", collectionSize);
    return [querySnapshot.docs, collectionSize];
  };

  getCollectionSearchByPrefixBySpecialConditions = async (
    collectionName,
    queryTarget,
    queryText,
    searchConditions,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget
  ) => {
    // //console.log(
    //   "getCollectionSearchByPrefix(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "searchConditions",
    //   searchConditions,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   ")"
    // );
    if (lastVisible === undefined) lastVisible = null;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    conditions = [...conditions, ...this.getConditionsFromQueryFilter(queryTarget, queryText, collectionName)];

    searchConditions.forEach((searchConditionItem) => {
      // //console.log("searchConditionItem=", searchConditionItem);
      conditions.push(where(searchConditionItem.field, searchConditionItem.operator, searchConditionItem.value));
    });

    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    if (queryTarget !== orderby && queryText !== "") {
      conditions.push(orderBy(queryTarget, ascDesc));
    }
    if (orderby !== "") {
      if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
      else conditions.push(orderBy(orderby, ascDesc));
    } else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);
    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    // //console.log("getCollectionSearchByPrefix() => conditions=", conditions, "collectionName=", collectionName);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    // //console.log("getCollectionSearchByPrefix() => querySnapshot=", querySnapshot);
    let collectionSize = await this.getCollectionSize(
      collectionName,
      queryTarget,
      queryText,
      firstVisible,
      lastVisible,
      pageSize,
      orderby,
      ascDesc,
      showAllVersions,
      vinculo_idEntidade,
      vinculoTarget
    );
    // //console.log("getCollectionSearchByPrefix() => collectionSize=", collectionSize);
    return [querySnapshot.docs, collectionSize];
  };

  getCollectionSearchBySpecialConditions = async (
    collectionName,
    searchConditions,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    show_1_Active_2_Inactive_3_Both
  ) => {
    // console.log(
    //   "getCollectionSearchBySpecialConditions(collectionName:",
    //   collectionName,
    //   "searchConditions:",
    //   searchConditions,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   "show_1_Active_2_Inactive_3_Both:",
    //   show_1_Active_2_Inactive_3_Both,
    //   ")"
    // );

    if (lastVisible === undefined) lastVisible = null;
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    let conditions = [];

    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    // //console.log("getCollectionSearchBySpecialConditions() => conditions=", conditions);

    searchConditions.forEach((searchConditionItem) => {
      // //console.log("searchConditionItem=", searchConditionItem);
      conditions.push(where(searchConditionItem.field, searchConditionItem.operator, searchConditionItem.value));
    });
    // //console.log("getCollectionSearchBySpecialConditions() => conditions=", conditions);

    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));

    // Adicionar ordenação se necessário
    if (orderby && Array.isArray(orderby)) {
      orderby.forEach((item) => conditions.push(orderBy(item, ascDesc)));
    } else if (orderby) {
      conditions.push(orderBy(orderby, ascDesc));
    }

    // Adicionar paginação se necessário
    if (pageSize !== null && pageSize !== undefined) {
      if (firstVisible !== null && firstVisible !== "") {
        conditions.push(limitToLast(pageSize));
      } else {
        conditions.push(limit(pageSize));
      }
    }

    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));

    // console.log("getCollectionSearchBySpecialConditions => collectionName:", collectionName, "conditions: ", conditions);
    
    // Buscar os documentos COM paginação
    const docsQuery = query(collection(db, collectionName), ...conditions);
    const querySnapshot = await getDocs(docsQuery);
    
    // Buscar o count total SEM limitações de paginação
    // Reconstruir as condições sem limit, startAfter, endBefore
    const countConditions = [];
    
    // Adicionar vínculo de entidade
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) countConditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else countConditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else countConditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    
    // Adicionar searchConditions
    searchConditions.forEach((searchConditionItem) => {
      countConditions.push(where(searchConditionItem.field, searchConditionItem.operator, searchConditionItem.value));
    });
    
    // Adicionar filtro de versões
    if (!showAllVersions) countConditions.push(where("metadados.active", "==", true));
    
    // NÃO adicionar ordenação, paginação, firstVisible ou lastVisible
    
    const countQuery = query(collection(db, collectionName), ...countConditions);
    const snapshot = await getCountFromServer(countQuery);
    
    return [querySnapshot.docs, snapshot.data().count];
  };

  getCollectionSearchByPartialWithoutSize = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget
  ) => {
    // //console.log(
    //   "getCollectionSearchByPrefix(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget
    // );
    if (lastVisible === undefined) lastVisible = null;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    conditions = [...conditions, ...this.getConditionsFromQueryFilter(queryTarget, queryText, collectionName)];
    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    // //console.log("getCollectionSearchByPartialWithoutSize() => queryTarget=", queryTarget, "queryText=", queryText);
    if (queryTarget !== orderby && queryText !== "") conditions.push(orderBy(queryTarget, ascDesc));
    // //console.log("getCollectionSearchByPartialWithoutSize() => orderby=", orderby);
    if (orderby !== "") {
      if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
      else conditions.push(orderBy(orderby, ascDesc));
    } else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);

    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    // //console.log("getCollectionSearchByPartialWithoutSize() => conditions=", conditions);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    return querySnapshot.docs;
  };

  getCollectionSearchByPrefixWithoutSize = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    show_1_Active_2_Inactive_3_Both,
    associacaoIdTarget,
    associacaoTarget,
    showBloqueados,
    extraConditions,
  ) => {
    // //console.log(
    //   "getCollectionSearchByPrefix(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   "associacaoIdTarget:",
    //   associacaoIdTarget,
    //   "associacaoTarget:",
    //   associacaoTarget,
    //   "showBloqueados:",
    //   showBloqueados,
    //   "extraConditions:",
    //   extraConditions,
    //   ")"
    // );
    if (lastVisible === undefined) lastVisible = null;
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    conditions = [...conditions, ...this.getConditionsFromQueryFilter(queryTarget, queryText, collectionName)];
    if (associacaoIdTarget) {
      conditions.push(where("dadosFiliacao.vinculadoAEntidadeID", "==", associacaoIdTarget));
    }
    else if (associacaoTarget) {
      conditions.push(where("dadosFiliacao.vinculadoAEntidade", "==", associacaoTarget));
    }
    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions) conditions.push(where("metadados.successorId", "==", ""));
    if (show_1_Active_2_Inactive_3_Both === 1) conditions.push(where("metadados.active", "==", true));
    else if (show_1_Active_2_Inactive_3_Both === 2) conditions.push(where("metadados.active", "==", false));
    if (showBloqueados) conditions.push(where("metadados.cancelado", "==", true));
    if (extraConditions !== null) conditions = [...conditions, ...extraConditions];
    // if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    // //console.log("getCollectionSearchByPrefix() => queryTarget=", queryTarget, "queryText=", queryText);
    if (queryTarget !== orderby && queryText !== "") conditions.push(orderBy(queryTarget, ascDesc));
    // //console.log("getCollectionSearchByPrefix() => orderby=", orderby);
    if (orderby !== "") {
      if (Array.isArray(orderby))
        orderby.forEach((item) => {
          if (!conditions.includes(orderBy(item))) conditions.push(orderBy(item));
        });
      else {
        if (!conditions.includes(orderBy(orderby, ascDesc))) conditions.push(orderBy(orderby, ascDesc));
        // conditions.push(orderBy(orderby, ascDesc));
      }
    } //else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);

    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    // console.log("getCollectionSearchByPrefix() => conditions=", conditions);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    return querySnapshot.docs;
  };

  getCollectionSearchByComplexFilter = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    show_1_Active_2_Inactive_3_Both
  ) => {
    //console.log(
    //   "getCollectionSearchByPrefix(collectionName:",
    //   collectionName,
    //   "queryTarget:",
    //   queryTarget,
    //   "queryText:",
    //   queryText,
    //   "firstVisible:",
    //   firstVisible,
    //   "lastVisible:",
    //   lastVisible,
    //   "pageSize:",
    //   pageSize,
    //   "orderby:",
    //   orderby,
    //   "ascDesc:",
    //   ascDesc,
    //   "vinculo_idEntidade:",
    //   vinculo_idEntidade,
    //   "vinculoTarget:",
    //   vinculoTarget,
    //   ")"
    // );
    if (lastVisible === undefined) lastVisible = null;
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    let conditions = [];
    if (vinculo_idEntidade) {
      if (vinculo_idEntidade !== null) {
        if (vinculoTarget) {
          if (vinculoTarget !== null) conditions.push(where(vinculoTarget, "==", vinculo_idEntidade));
          else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
        } else conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
      }
    }
    //interar para cada propriedade de querytext

    if (queryText) {
      if (queryText !== "") {
        if (queryText.searchInfo && queryText.searchInfo !== "")
          conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText.searchInfo)]));
        let queryTextArray = Object.entries(queryText);
        queryTextArray.forEach((item) => {
          if (!["", "Todos", "Todas", "Selecione"].includes(item[1])) conditions.push(where(item[0], "==", item[1]));
        });
      }
    }

    // if (queryText !== "") conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText)]));
    if (!showAllVersions) conditions.push(where("metadados.successorId", "==", ""));
    // //console.log("getCollectionSearchByComplexFilter() => show_1_Active_2_Inactive_3_Both=", show_1_Active_2_Inactive_3_Both);
    if (show_1_Active_2_Inactive_3_Both === 1) conditions.push(where("metadados.active", "==", true));
    else if (show_1_Active_2_Inactive_3_Both === 2) conditions.push(where("metadados.active", "==", false));
    // if (!showAllVersions) conditions.push(where("metadados.active", "==", true));
    if (pageSize !== null) {
      if (firstVisible !== null && firstVisible !== "") conditions.push(limitToLast(pageSize));
      else conditions.push(limit(pageSize));
    }
    // //console.log("getCollectionSearchByComplexFilter() => queryTarget=", queryTarget, "queryText=", queryText);
    if (queryTarget !== orderby && queryText !== "") conditions.push(orderBy(queryTarget, ascDesc));
    // //console.log("getCollectionSearchByComplexFilter() => orderby=", orderby);
    if (orderby !== "") {
      if (Array.isArray(orderby)) orderby.map((item) => conditions.push(orderBy(item)));
      else conditions.push(orderBy(orderby, ascDesc));
    } else conditions.push(orderBy(orderby, ascDesc));
    conditions = keepOrderIfNotDuplicated(conditions);

    if (firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    if (lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    //console.log("getCollectionSearchByComplexFilter() => conditions=", conditions);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    //console.log("getCollectionSearchByComplexFilter() => querySnapshot=", querySnapshot);
    let collectionSize = await this.getCollectionSizeByComplexFilter(
      collectionName,
      queryTarget,
      queryText,
      firstVisible,
      lastVisible,
      pageSize,
      orderby,
      ascDesc,
      showAllVersions,
      vinculo_idEntidade,
      vinculoTarget
    );
    // //console.log("getCollectionSearchByPrefix() => collectionSize=", collectionSize);
    return [querySnapshot.docs, collectionSize];
  };

  getPrevPage = async (
    collectionName,
    queryTarget,
    queryText,
    firstVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget
  ) => {
    // //console.log(
    //   "collectionName=",
    //   collectionName,
    //   " queryTarget=",
    //   queryTarget,
    //   " queryText=",
    //   queryText,
    //   " firstVisible=",
    //   firstVisible,
    //   " pageSize=",
    //   pageSize,
    //   " orderby=",
    //   orderby,
    //   " ascDesc=",
    //   ascDesc,
    //   "showAllVersions=",
    //   showAllVersions,
    //   " vinculo_idEntidade=",
    //   vinculo_idEntidade
    // );
    if (typeof queryText === "string") {
      return this.getCollectionSearchByPrefix(
        collectionName,
        queryTarget,
        queryText,
        firstVisible,
        null,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget
      );
    } else {
      return this.getCollectionSearchByComplexFilter(
        collectionName,
        queryTarget,
        queryText,
        firstVisible,
        null,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget
      );
    }
  };

  getNextPage = async (
    collectionName,
    queryTarget,
    queryText,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget
  ) => {
    //console.log(
    //   "collectionName=",
    //   collectionName,
    //   " queryTarget=",
    //   queryTarget,
    //   " queryText=",
    //   queryText,
    //   " lastVisible=",
    //   lastVisible,
    //   " pageSize=",
    //   pageSize,
    //   " orderby=",
    //   orderby,
    //   " ascDesc=",
    //   ascDesc,
    //   "showAllVersions=",
    //   showAllVersions,
    //   " vinculo_idEntidade=",
    //   vinculo_idEntidade,
    //   " vinculoTarget=",
    //   vinculoTarget
    // );
    if (typeof queryText === "string") {
      return this.getCollectionSearchByPrefix(
        collectionName,
        queryTarget,
        queryText,
        null,
        lastVisible,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget
      );
    } else {
      return this.getCollectionSearchByComplexFilter(
        collectionName,
        queryTarget,
        queryText,
        null,
        lastVisible,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget
      );
    }
  };

  getMorePage = async (
    collectionName,
    queryTarget,
    queryText,
    lastVisible,
    pageSize,
    orderby,
    ascDesc,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    show_1_Active_2_Inactive_3_Both,
    associacaoIdTarget,
    associacaoTarget,
    showBloqueados,
    extraConditions
  ) => {
    // //console.log(
    //   "collectionName=",
    //   collectionName,
    //   " queryTarget=",
    //   queryTarget,
    //   " queryText=",
    //   queryText,
    //   " lastVisible=",
    //   lastVisible,
    //   " pageSize=",
    //   pageSize,
    //   " orderby=",
    //   orderby,
    //   " ascDesc=",
    //   ascDesc,
    //   "showAllVersions=",
    //   showAllVersions,
    //   " vinculo_idEntidade=",
    //   vinculo_idEntidade,
    //   " vinculoTarget=",
    //   vinculoTarget
    // );

    // if (queryText.substring(0, 1) === "%" || queryText.substring(0, 1) === "*" || queryText.substring(0, 1) === "?") {
    //   return this.getCollectionSearchByPartialWithoutSize(
    //     collectionName,
    //     queryTarget,
    //     queryText.substring(1, queryText.length),
    //     null,
    //     lastVisible,
    //     pageSize,
    //     orderby,
    //     ascDesc,
    //     showAllVersions,
    //     vinculo_idEntidade,
    //     vinculoTarget
    //   );
    // } else {
    if (show_1_Active_2_Inactive_3_Both === undefined) show_1_Active_2_Inactive_3_Both = 1;
    if (typeof queryText === "string") {
      return this.getCollectionSearchByPrefixWithoutSize(
        collectionName,
        queryTarget,
        queryText,
        null,
        lastVisible,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget,
        show_1_Active_2_Inactive_3_Both,
        associacaoIdTarget,
        associacaoTarget,
        showBloqueados,
        extraConditions
      );
    } else {
      return this.getCollectionSearchByComplexFilter(
        collectionName,
        queryTarget,
        queryText,
        null,
        lastVisible,
        pageSize,
        orderby,
        ascDesc,
        showAllVersions,
        vinculo_idEntidade,
        vinculoTarget,
        show_1_Active_2_Inactive_3_Both,
        associacaoIdTarget,
        associacaoTarget,
        showBloqueados,
        extraConditions
      );
    }
    // }
  };

  getConditionsFromQueryFilter = (queryTarget, queryFilter, collectionName) => {
    let conditions = [];
    // let searchInfoText = "";
    // //console.log("getConditionsFromQueryFilter => queryTarget=", queryTarget, "queryFilter=", queryFilter);
    if (queryFilter !== undefined) {
      if (typeof queryFilter === "object") {
        if (queryFilter.situacaoSearch !== "Todas") conditions.push(where("situacao", "==", queryFilter.situacaoSearch));
        if (queryFilter.searchInfo)
          conditions = [...conditions, ...this.getWhereQyeryConditionsFromQueryFilter(queryTarget, queryFilter.searchInfo, collectionName)];
        if (queryFilter.filiacao)
          conditions = [...conditions, where("filiacao", "==", queryFilter.filiacao)];
        if (queryFilter.vinculadoAEntidadeID)
          conditions = [...conditions, where("vinculadoAEntidadeID", "==", queryFilter.vinculadoAEntidadeID)];
      } else if (typeof queryFilter === "string") {
        conditions = [...conditions, ...this.getWhereQyeryConditionsFromQueryFilter(queryTarget, queryFilter, collectionName)];
      }
    }
    // //console.log("getConditionsFromQueryFilter => conditions=", conditions);
    return conditions;
  };

  getConditionsFromQueryFilter_version2 = (queryTarget, queryFilter, collectionName) => {
    let conditions = [];
    // let searchInfoText = "";
    // console.log("getConditionsFromQueryFilter_version2 => queryTarget=", queryTarget, "queryFilter=", queryFilter);
    if (queryFilter !== undefined) {
      if (typeof queryFilter === "object") {
        if (queryFilter.situacaoSearch && queryFilter.situacaoSearch !== "Todas") conditions.push(where("situacao", "==", queryFilter.situacaoSearch));
        if (queryFilter.searchInfo)
          conditions = [...conditions, ...this.getWhereQyeryConditionsFromQueryFilter(queryTarget, queryFilter.searchInfo, collectionName)];
        if (queryFilter.filiacao) {
          conditions = [...conditions, where("filiacao", "==", queryFilter.filiacao)];
          if (queryFilter.vinculadoAEntidadeID)
            conditions = [...conditions, where("vinculadoAEntidadeID", "==", queryFilter.vinculadoAEntidadeID)];
        }
        else if (queryFilter.federacao) {
          conditions = [...conditions, where("dadosFiliacao.federacao", "==", queryFilter.federacao)];
          if (queryFilter.vinculadoAEntidadeID)
            conditions = [...conditions, where("dadosFiliacao.vinculadoAEntidadeID", "==", queryFilter.vinculadoAEntidadeID)];
        }
      } else if (typeof queryFilter === "string") {
        conditions = [...conditions, ...this.getWhereQyeryConditionsFromQueryFilter(queryTarget, queryFilter, collectionName)];
      }
    }
    // console.log("getConditionsFromQueryFilter => conditions=", conditions);
    return conditions;
  };

  getWhereQyeryConditionsFromQueryFilter = (queryTarget, queryFilter, collectionName) => {
    const conditions = [];
    if (queryFilter.length > 0) {
      queryFilter = queryFilter.trim().toLowerCase().replaceAll("  ", " ");
      if (["%", "*", "?", "$"].includes(queryFilter.substring(0, 1))) {
        const cleanedQueryFilter = queryFilter.substring(1, queryFilter.length);
        const trigrams = cleanedQueryFilter.split(" ").slice(0, 10);
        conditions.push(where(queryTarget, "array-contains-any", [...trigrams]));
        if (queryFilter.searchInfo) {
          if (queryFilter.searchInfo.length > 0) conditions.push(orderBy(queryTarget, "asc"));
        }
      } else {
        queryTarget = queryTarget.replace("trigam", "searchableName").replace("trigam", "name");
        // Nas coleções de COLECOES_SEARCHABLENAME_NORMALIZADO o campo é gravado sem
        // acento; o termo tem de passar pela MESMA normalização, senão digitar o nome
        // com acento não alcança o documento. Nas demais coleções o dado ainda guarda
        // o acento e o termo segue só em minúsculas.
        // (O ramo de trigrama acima NÃO pode ser normalizado: generateTrigam gera os
        // termos COM acento.)
        const prefixo = normalizarTermoBusca(queryFilter, collectionName);
        conditions.push(where(queryTarget, ">=", prefixo));
        conditions.push(where(queryTarget, "<=", prefixo + "\uf8ff"));
        //O orderBy abaixo é necessário para que o startAfter e o endBefore funcionem corretamente
        conditions.push(orderBy(queryTarget, "asc"));
      }
    }
    return conditions;
  };

  getCollectionByConditions = async (
    collectionName,
    conditions
  ) => {
    // Get appropriate Firebase database for this collection
    const targetDb = multiFirebaseService.getDb(collectionName);
    
    let querySnapshot = await getDocs(query(collection(targetDb, collectionName), ...conditions))
      .catch((error) => {
        console.error("Error getting document:", error);
        throw error;
      });
    
    let collectionSize = await this.getCollectionSizeByConditions(
      collectionName,
      conditions
    )
      .catch((error) => {
        console.error("Error getting document:", error);
        throw error;
      });
    // console.log("getCollectionSearchByPrefix() => collectionSize=", collectionSize);
    return [querySnapshot.docs, collectionSize];
  };

  getCollectionSizeByConditions = async (
    collectionName,
    conditions
  ) => {
    try {
      // console.log("getCollectionSizeByConditions() => collectionName=", collectionName, "conditions=", conditions);
      
      // Get appropriate Firebase database for this collection
      const targetDb = multiFirebaseService.getDb(collectionName);
      
      let snapshot = await getCountFromServer(query(collection(targetDb, collectionName), ...conditions))
        .then((snapshot) => {
          // console.log("getCollectionSizeByConditions() => snapshot=", snapshot);
          return snapshot;
        })
        .catch((error) => {
          console.error("Error getting document:", error);
          throw error;
        });
      // console.log("getCollectionSizeByConditions() => snapshot=", snapshot);
      return snapshot.data().count;

    } catch (error) {
      console.error("Error getting document:", error);
      throw error;
    }
  };

  /**
   * Busca documentos em uma coleção com suporte a paginação
   * @param {string} collectionName - Nome da coleção
   * @param {Array} conditions - Condições de consulta
   * @param {DocumentSnapshot} lastVisible - Último documento visível (para paginação)
   * @returns {Object} - Objeto com docs (documentos) e lastVisible (último documento)
   */
  getCollectionByConditionsWithPagination = async (
    collectionName,
    conditions,
    lastVisible
  ) => {

    // Inicia monitoramento de desempenho
    performanceMonitor.startOperation('getCollectionByConditionsWithPagination', {
      collection: collectionName,
      conditionCount: conditions?.length || 0,
      isPaginated: !!lastVisible
    });

    let queryObj;

    // Se tem lastVisible, adiciona startAfter para paginação
    if (lastVisible) {
      queryObj = query(
        collection(db, collectionName),
        ...conditions,
        startAfter(lastVisible)
      );
    } else {
      // Consulta inicial sem paginação
      queryObj = query(
        collection(db, collectionName),
        ...conditions
      );
    }

    try {
      // Mede o tempo da operação de consulta no Firestore especificamente
      performanceMonitor.startOperation('firestore_getDocs', { 
        collection: collectionName 
      });
      
      const querySnapshot = await getDocs(queryObj);
      
      // Finaliza medição da consulta Firestore
      performanceMonitor.endOperation('firestore_getDocs', {
        docCount: querySnapshot.docs.length
      });


      // Pega o último documento visível para próxima página
      const lastVisibleDoc = querySnapshot.docs.length > 0
        ? querySnapshot.docs[querySnapshot.docs.length - 1]
        : null;

      // Finaliza monitoramento de desempenho da operação completa
      performanceMonitor.endOperation('getCollectionByConditionsWithPagination', {
        resultCount: querySnapshot.docs.length,
        hasMorePages: !!lastVisibleDoc
      });

      return {
        docs: querySnapshot.docs,
        lastVisible: lastVisibleDoc
      };
    } catch (error) {
      // Registra erro no monitoramento
      performanceMonitor.endOperation('getCollectionByConditionsWithPagination', {
        error: error.message,
        status: 'failed'
      });
      
      console.error("Erro na consulta paginada:", error);
      throw error;
    }
  };

  // ========================================================================================
  // NOVOS MÉTODOS PARA SearchPessoaComponentVersion5 - BUSCA POR NORMALIZED TRIGRAM
  // ========================================================================================

  /**
   * Busca por normalizedTrigram com vínculo - Version5 específico
   * Usado para CPF/CNPJ diretos quando há vínculo de entidade
   */
  getCollectionSearchByNormalizedTrigramWithVinculo = async (
    collectionName,
    searchTarget,
    searchText,
    pageSize,
    onlyActive,
    showAllVersions,
    vinculo_idEntidade,
    vinculoTarget,
    extraConditions = []
  ) => {

    try {
      const conditions = [...extraConditions];

      // Vínculo de entidade
      if (vinculo_idEntidade) {
        const target = vinculoTarget || "vinculo.idEntidade";
        conditions.push(where(target, "==", vinculo_idEntidade));
      }

      // Filtro de versões
      if (!showAllVersions) {
        conditions.push(where("isLatestVersion", "==", true));
      }

      // Filtro de ativos
      if (onlyActive) {
        conditions.push(where("cbtkdActive", "==", true));
      }

      // Busca exata por campo (CPF/CNPJ)
      conditions.push(where(searchTarget, "==", searchText));
      
      // Ordenação e limite
      conditions.push(orderBy(searchTarget, "asc"));
      conditions.push(limit(pageSize || 50));

      const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      
      return querySnapshot.docs;

    } catch (error) {
      console.error("Erro na busca por normalizedTrigram com vínculo:", error);
      throw error;
    }
  };

  /**
   * Busca por normalizedTrigram sem vínculo - Version5 específico
   * Usado para CPF/CNPJ diretos quando não há vínculo de entidade
   */
  getCollectionSearchByNormalizedTrigramSemVinculo = async (
    collectionName,
    searchTarget,
    searchText,
    pageSize,
    onlyActive,
    showAllVersions,
    vinculo_idEntidade,
    extraConditions = [],
    entidadeFiliadoFilter = null
  ) => {

    try {
      const conditions = [...extraConditions];

      // Filtro de versões
      if (!showAllVersions) {
        conditions.push(where("isLatestVersion", "==", true));
      }

      // Filtro de ativos
      if (onlyActive) {
        conditions.push(where("cbtkdActive", "==", true));
      }

      // Filtro de entidade filiado se especificado
      if (entidadeFiliadoFilter) {
        conditions.push(where("dadosFiliacao.federacaoID", "==", entidadeFiliadoFilter));
      }

      // Busca exata por campo (CPF/CNPJ)
      conditions.push(where(searchTarget, "==", searchText));
      
      // Ordenação e limite
      conditions.push(orderBy(searchTarget, "asc"));
      conditions.push(limit(pageSize || 50));

      const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      
      return querySnapshot.docs;

    } catch (error) {
      console.error("Erro na busca por normalizedTrigram sem vínculo:", error);
      throw error;
    }
  };

  /**
   * Busca documentos em uma coleção com fallback automático
   * Tenta primeiro via Firebase direto (mais rápido), depois via API se necessário
   * @param {string} collectionName - Nome da coleção
   * @param {Array} conditions - Array de condições do Firestore
   * @returns {Promise<Array>} - [documents, totalCount] - Mesmo formato do método original
   */
  getCollectionByConditionsFromAPI = async (collectionName, conditions) => {
    try {
      // console.log("GenericVinculadoService.getCollectionByConditionsFromAPI(", collectionName, conditions, ")");
      
      // Primeira tentativa: acesso direto ao Firebase (mais rápido)
      try {
        const result = await this.getCollectionByConditions(collectionName, conditions);
        return result;
      } catch (firebaseError) {
        // Se erro de permissão, conexão ou limite, tentar API
        console.warn(`Erro no acesso direto ao Firebase para ${collectionName}:`, firebaseError.message);
        
        // Segunda tentativa: via API como fallback
        // Converter condições do Firestore para formato da API
        const apiConditions = this.convertFirestoreConditionsToAPI(conditions);
        
        // Preparar dados para a requisição
        const requestData = {
          collectionName: collectionName,
          conditions: apiConditions
        };

        // 🔐 09/09/2026: /api/generic passou a exigir Bearer. Este fallback ia
        // sem token nenhum — e a rota lê com Admin SDK, por cima das Security
        // Rules. Agora vai autenticado como o usuário da sessão.
        const response = await AuthenticatedApiService.fetch('/api/generic/getCollectionByConditions', requestData);

        if (!response.ok) {
          // Se API também falhou, lançar erro original do Firebase
          console.error(`API também falhou (${response.status}). Erro original do Firebase:`, firebaseError.message);
          throw firebaseError;
        }

        const result = await response.json();

        // Converter os documentos para o formato esperado (simular DocumentSnapshot)
        const docs = result.data.map(doc => {
          // Converter strings de data de volta para Timestamp
          const convertedDoc = this.convertDateStringsToTimestamp(doc);
          
          return {
            id: convertedDoc.id,
            data: () => convertedDoc,
            exists: () => true
          };
        });

        // Retornar no mesmo formato do método original [docs, count]
        return [docs, result.totalCount];
      }

    } catch (error) {
      console.error(`Erro final em getCollectionByConditionsFromAPI para ${collectionName}:`, error);
      throw error;
    }
  };

  /**
   * Converte condições do Firestore para o formato esperado pela API
   * @param {Array} firestoreConditions - Array de condições do Firestore (where, orderBy, etc.)
   * @returns {Array} - Array de condições no formato da API
   */
  convertFirestoreConditionsToAPI = (firestoreConditions) => {
    const apiConditions = [];

    if (!Array.isArray(firestoreConditions)) {
      console.warn('convertFirestoreConditionsToAPI: condições não são um array válido');
      return apiConditions;
    }

    firestoreConditions.forEach((condition, index) => {
      try {
        // Verificar se é uma condição where - suporte para diferentes formatos
        let whereCondition = null;
        let fieldPath = null;
        let operator = null;
        let value = null;

        // Formato 1: Objeto com _delegate (Firebase v9+)
        if (condition && condition._delegate && condition._delegate.type === 'where') {
          whereCondition = condition._delegate;
          
          // Extrair o campo
          if (whereCondition.field && whereCondition.field.canonicalString) {
            fieldPath = whereCondition.field.canonicalString();
          } else if (whereCondition.field && typeof whereCondition.field === 'string') {
            fieldPath = whereCondition.field;
          }

          // Extrair operador
          operator = whereCondition.op;

          // Extrair o valor
          if (whereCondition.value && whereCondition.value.value !== undefined) {
            value = whereCondition.value.value;
          } else if (whereCondition.value !== undefined) {
            value = whereCondition.value;
          }
        }
        // Formato 2: Objeto direto com _field, _op, _value (Firebase interno)
        else if (condition && condition.type === 'where' && condition._field && condition._op !== undefined && condition._value !== undefined) {
          // Extrair campo
          if (condition._field && condition._field.canonicalString) {
            fieldPath = condition._field.canonicalString();
          } else if (condition._field && typeof condition._field === 'string') {
            fieldPath = condition._field;
          } else if (condition._field && condition._field.path) {
            fieldPath = condition._field.path;
          }

          // Extrair operador e valor
          operator = condition._op;
          value = condition._value;
        }
        
        // Verificar se conseguimos extrair todas as informações necessárias
        if (fieldPath && operator !== undefined && value !== undefined) {
          // Converter valores Date para ISO string se necessário
          if (value instanceof Date) {
            value = value.toISOString();
          }

          apiConditions.push({
            field: fieldPath,
            operator: operator,
            value: value
          });


        } else {
          console.warn(`Condição ${index}: dados incompletos. Field: ${fieldPath}, Operator: ${operator}, Value: ${value}`, condition);
        }
      } catch (error) {
        console.error(`Erro ao converter condição ${index}:`, error, condition);
      }
    });

    return apiConditions;
  };
}

export default new GenericVinculadoService();
